import { exists } from "@examspark/common-util";
import { SearchableResourceFilterInput } from "@examspark/types";
import { SearchFields } from "@examspark/types/dist/components/activity-editor";

import { UseSearchProps } from "../useSearch";

import { getGenericQuery, getSearchQueryForField } from "./buildQuery";

export const buildFilter = (
  params: {
    filter: SearchFields;
  } & Pick<UseSearchProps, "baseFilter">,
) => {
  const filter: SearchableResourceFilterInput =
    JSON.parse(JSON.stringify(params.baseFilter)) ?? {};

  if (!filter.and) filter.and = [];
  if (params?.filter.query) {
    filter.and.push(...getGenericQuery(params.filter.query));
  }
  if (params?.filter.interaction) {
    filter.and.push(
      getSearchQueryForField("interaction", params.filter.interaction),
    );
  }
  if (params?.filter.bankId) {
    filter.and.push(getSearchQueryForField("bankId", params.filter.bankId));
  }
  if (params?.filter.sk) {
    filter.and.push(getSearchQueryForField("sk", params.filter.sk));
  }
  if (params?.filter.workspaceId) {
    filter.and.push(
      getSearchQueryForField("workspaceId", params.filter.workspaceId),
    );
  }
  if (params?.filter.subject) {
    filter.and.push(getSearchQueryForField("subject", params.filter.subject));
  }
  if (params?.filter.grade) {
    filter.and.push(getSearchQueryForField("grade", params.filter.grade));
  }
  if (params?.filter.blooms) {
    filter.and.push(getSearchQueryForField("blooms", params.filter.blooms));
  }
  if (params?.filter.dok) {
    filter.and.push(getSearchQueryForField("dok", params.filter.dok));
  }
  if (params?.filter.language) {
    filter.and.push(getSearchQueryForField("language", params.filter.language));
  }
  if (params?.filter.objectiveScope) {
    filter.and.push(
      getSearchQueryForField("objectiveScope", params.filter.objectiveScope),
    );
  }
  if (params?.filter.alignmentIds) {
    filter.and.push(
      getSearchQueryForField("alignmentIds", params.filter.alignmentIds),
    );
  }
  if (params?.filter.referencesIdsUnit) {
    filter.and.push(
      getSearchQueryForField("referencesIds", params.filter.referencesIdsUnit),
    );
  }
  if (params?.filter.tag) {
    filter.and.push({
      or: params.filter.tag.map((tag) => ({
        tags: {
          eq: tag.value != null ? `${tag.key}#${tag.value}` : tag.key,
        },
      })),
    });
  }
  if (params?.filter.deliveryMediaType) {
    filter.and.push(
      getSearchQueryForField(
        "deliveryMediaType",
        params.filter.deliveryMediaType,
      ),
    );
  }

  // remove any empty filters
  filter.and = filter.and.filter(exists);

  return filter;
};
